import ApplicantsActionTypes from 'redux/applicants/types';

const INITIAL_STATE = {
  processingApplicant: false,
  batchProcessingApplicant: false,
  // applications
  applications: [],
  searchingApplication: false,
  fetchingApplications: false,
  fetchingApplicationsError: false,

  // applicant fetched form
  applicantFormData: null,
  fetchingApplicantFormData: true,
  formSchema: null,
  fetchingFormSchema: false,

  // candidates
  newCandidates: {
    data: [],
  },
  isFetchingCandidates: false,

  keepInViewCandidates: {
    data: [],
  },
  isFetchingkeepInViewCandidates: false,

  admittedCandidates: {
    data: [],
  },
  isFetchingadmittedCandidates: false,

  declinedCandidates: {
    data: [],
  },
  isFetchingdeclinedCandidates: false,

  // notify applicant
  notifyingApplicants: false,
  error: null,

  // export applicants data
  dataExportLoading: false,

  // email
  sendingEmail: false,
  fetchingEmail: false,
  candidateEmail: [],

  // transactions
  fetchingTransactions: false,
  candidateTransactions: [],

  // pre-loaded stats
  fetchingPreloadedCandidatesStats: false,
  preloadedStats: null,
};

function ApplicantReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    // pre-loaded stats
    case ApplicantsActionTypes.FETCH_PRELOADED_STATS_START:
      return {
        ...state,
        fetchingPreloadedCandidatesStats: true,
      };
    case ApplicantsActionTypes.FETCH_PRELOADED_STATS_SUCCESS:
      return {
        ...state,
        fetchingPreloadedCandidatesStats: false,
        preloadedStats: payload,
      };
    case ApplicantsActionTypes.FETCH_PRELOADED_STATS_FAILURE:
      return {
        ...state,
        fetchingPreloadedCandidatesStats: false,
        error: payload,
      };

    // applications
    case ApplicantsActionTypes.START_FETCH_APPLICANT_APPLICATION:
      return {
        ...state,
        fetchingApplications: true,
        searchingApplication: false,
      };
    case ApplicantsActionTypes.START_FETCH_APPLICANT_APPLICATION_SUCCESS:
      return {
        ...state,
        fetchingApplications: false,
        applications: payload,
      };
    case ApplicantsActionTypes.START_FETCH_APPLICANT_APPLICATION_FAILURE:
      return {
        ...state,
        fetchingApplications: false,
        fetchingApplicationsError: payload,
      };

    // search applications
    case ApplicantsActionTypes.SEARCH_APPLICANTS_APPLICATION_START:
      return {
        ...state,
        searchingApplication: true,
      };

    // export data
    case ApplicantsActionTypes.EXPORT_APPLICANTS_DATA_START:
      return {
        ...state,
        dataExportLoading: true,
      };
    case ApplicantsActionTypes.EXPORT_APPLICANTS_DATA_SUCCESS:
      return {
        ...state,
        dataExportLoading: false,
      };
    case ApplicantsActionTypes.EXPORT_APPLICANTS_DATA_FAILURE:
      return {
        ...state,
        dataExportLoading: false,
        error: payload,
      };

    // new applicants
    case ApplicantsActionTypes.START_FETCH_APPLICANTS:
      return {
        ...state,
        isFetchingCandidates: true,
        error: null,
      };
    case ApplicantsActionTypes.FETCH_APPLICANTS_SUCCESS:
      return {
        ...state,
        isFetchingCandidates: false,
        newCandidates: payload,
      };
    case ApplicantsActionTypes.FETCH_APPLICANTS_FAILURE:
      return {
        ...state,
        isFetchingCandidates: false,
        error: payload,
      };

    // keep in view applicants
    case ApplicantsActionTypes.START_FETCH_KEEP_IN_VIEW_APPLICANTS:
      return {
        ...state,
        isFetchingkeepInViewCandidates: true,
        error: null,
      };
    case ApplicantsActionTypes.FETCH_KEEP_IN_VIEW_APPLICANTS_SUCCESS:
      return {
        ...state,
        isFetchingkeepInViewCandidates: false,
        keepInViewCandidates: payload,
      };
    case ApplicantsActionTypes.FETCH_KEEP_IN_VIEW_APPLICANTS_FAILURE:
      return {
        ...state,
        isFetchingkeepInViewCandidates: false,
        error: payload,
      };

    // admitted applicants
    case ApplicantsActionTypes.START_FETCH_ADMITTED_APPLICANTS:
      return {
        ...state,
        isFetchingadmittedCandidates: true,
        error: null,
      };
    case ApplicantsActionTypes.FETCH_ADMITTED_APPLICANTS_SUCCESS:
      return {
        ...state,
        isFetchingadmittedCandidates: false,
        admittedCandidates: payload,
      };
    case ApplicantsActionTypes.FETCH_ADMITTED_APPLICANTS_FAILURE:
      return {
        ...state,
        isFetchingadmittedCandidates: false,
        error: payload,
      };

    // declined applicants
    case ApplicantsActionTypes.START_FETCH_DECLINED_APPLICANTS:
      return {
        ...state,
        isFetchingdeclinedCandidates: true,
        error: null,
      };
    case ApplicantsActionTypes.FETCH_DECLINED_APPLICANTS_SUCCESS:
      return {
        ...state,
        isFetchingdeclinedCandidates: false,
        declinedCandidates: payload,
      };
    case ApplicantsActionTypes.FETCH_DECLINED_APPLICANTS_FAILURE:
      return {
        ...state,
        isFetchingdeclinedCandidates: false,
        error: payload,
      };

    // applicants form data
    case ApplicantsActionTypes.START_FETCH_APPLICANTS_FORM:
      return {
        ...state,
        fetchingApplicantFormData: true,
        error: null,
      };
    case ApplicantsActionTypes.FETCH_APPLICANTS_FORM_SUCCESS:
      return {
        ...state,
        fetchingApplicantFormData: false,
        applicantFormData: payload,
      };
    case ApplicantsActionTypes.FETCH_APPLICANTS_FORM_FAILURE:
      return {
        ...state,
        fetchingApplicantFormData: false,
        error: payload,
      };

    // applicants form schema
    case ApplicantsActionTypes.START_FETCH_FORM_SCHEMA:
      return {
        ...state,
        fetchingFormSchema: true,
        error: null,
      };
    case ApplicantsActionTypes.FETCH_FORM_SCHEMA_SUCCESS:
      return {
        ...state,
        fetchingFormSchema: false,
        formSchema: payload,
      };
    case ApplicantsActionTypes.FETCH_FORM_SCHEMA_FAILURE:
      return {
        ...state,
        fetchingFormSchema: false,
        error: payload,
      };

    // applicant stage change
    case ApplicantsActionTypes.PROCESS_APPLICANT_STAGE:
      return {
        ...state,
        processingApplicant: true,
      };
    case ApplicantsActionTypes.PROCESS_SUCCESSFUL_STAGE_UPDATE:
      return {
        ...state,
        processingApplicant: false,
      };
    case ApplicantsActionTypes.PROCESS_FAILED_STAGE_UPDATE:
      return {
        ...state,
        processingApplicant: false,
        error: payload,
      };

    // batch applicant stage change
    case ApplicantsActionTypes.BATCH_PROCESS_APPLICANT_STAGE:
      return {
        ...state,
        batchProcessingApplicant: true,
      };
    case ApplicantsActionTypes.BATCH_PROCESS_SUCCESSFUL_STAGE_UPDATE:
      return {
        ...state,
        batchProcessingApplicant: false,
      };
    case ApplicantsActionTypes.BATCH_PROCESS_FAILED_STAGE_UPDATE:
      return {
        ...state,
        batchProcessingApplicant: false,
        error: payload,
      };

    case ApplicantsActionTypes.NOTIFY_APPLICANT_START:
      return {
        ...state,
        notifyingApplicants: true,
      };
    case ApplicantsActionTypes.NOTIFY_APPLICANT_SUCCESS:
      return {
        ...state,
        notifyingApplicants: false,
      };
    case ApplicantsActionTypes.NOTIFY_APPLICANT_FAILURE:
      return {
        ...state,
        notifyingApplicants: false,
        error: payload,
      };

    // email candidate
    case ApplicantsActionTypes.SEND_EMAIL_START:
      return {
        ...state,
        sendingEmail: true,
      };
    case ApplicantsActionTypes.SEND_EMAIL_SUCCESS:
      return {
        ...state,
        sendingEmail: false,
      };
    case ApplicantsActionTypes.SEND_EMAIL_FAILURE:
      return {
        ...state,
        sendingEmail: false,
        error: payload,
      };

    case ApplicantsActionTypes.FETCH_EMAIL_START:
      return {
        ...state,
        fetchingEmail: true,
      };
    case ApplicantsActionTypes.FETCH_EMAIL_SUCCESS:
      return {
        ...state,
        fetchingEmail: false,
        candidateEmail: payload,
      };
    case ApplicantsActionTypes.FETCH_EMAIL_FAILURE:
      return {
        ...state,
        fetchingEmail: false,
        error: payload,
      };

    // candidate transactions
    case ApplicantsActionTypes.FETCH_APPLICANT_TRANSACTIONS_START:
      return {
        ...state,
        fetchingTransactions: true,
      };
    case ApplicantsActionTypes.FETCH_APPLICANT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        fetchingTransactions: false,
        candidateTransactions: payload,
      };
    case ApplicantsActionTypes.FETCH_APPLICANT_TRANSACTIONS_FAILURE:
      return {
        ...state,
        fetchingTransactions: false,
        error: payload,
      };

    default:
      return state;
  }
}

export default ApplicantReducer;
